import React from "react"
import styled, { keyframes } from "styled-components";

const MarkqueeRightToLeft = keyframes`
    0%   { transform: translate(0, 0); }
    100% { transform: translate(-100%, 0); }
`;

const MarkqueeWrap = styled.div`
    display: block;
    height: 30px;
    width: 100%;
    background:#fab702;
    padding: 5px;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    position: fixed;
    z-index: 10;
    top:60px;
    @media (min-width: 1024px){
        top:84px;
    }
    @media (min-width: 1280px){
        top:90px;
    }
    & a{
        font-weight:600;
        color:#fff;
        font-size: 14px;
        line-height: 1;
        height: 20px;
        &:hover, &:focus{
            color:#fff;
        }
    }
`
const Markquee = styled.div`   
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
`
const SiteMarkquee = styled.div`
    display: inline-block; 
    padding-left: 100%;
    animation-duration: 50s;
    animation-name: ${MarkqueeRightToLeft};
    animation-iteration-count:infinite;
    animation-timing-function: linear;
    &:hover { 
        animation-play-state: paused; 
    }
`

const Markquees = () => {
  return (
    <MarkqueeWrap className="markquee">
        <div className="container">
            <Markquee>
                <SiteMarkquee><strong>Welcome to AES. Wolter Motors is now part of our family at AES. If you have any inquiries or require assistance, feel free to reach out at <a href="tel:8663861001">866-386-1001</a>. We're here to support you.</strong></SiteMarkquee> 
            </Markquee>
        </div>
    </MarkqueeWrap>
  )
}

export default Markquees